import aircraft from "@/assets/images/aircraft.png";
import styles from "./index.module.scss";
import { Helmet } from "react-helmet";
import { useTranslation } from "@/i18n/client";

const PageNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["centered-container"]}>
      <Helmet>
        <title>{t("seo.title.notFound")} | Joybuy</title>
        <meta name="description" content={t("seo.description.notFound")} />
      </Helmet>
      <img src={aircraft.src} alt="404 not found" />
      <div className={styles.title}>{`404 ${t("common.error404")}`}</div>
    </div>
  );
};

export default PageNotFound;
